import { render, staticRenderFns } from "./ProjectManagementSettings.vue?vue&type=template&id=64e05640&scoped=true"
import script from "./ProjectManagementSettings.vue?vue&type=script&lang=js"
export * from "./ProjectManagementSettings.vue?vue&type=script&lang=js"
import style0 from "./ProjectManagementSettings.vue?vue&type=style&index=0&id=64e05640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e05640",
  null
  
)

export default component.exports